import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=7b80e4e8&scoped=true&lang=pug&"
import script from "./TableActions.vue?vue&type=script&lang=js&"
export * from "./TableActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b80e4e8",
  null
  
)

export default component.exports